import api from "../Configuration/ApiConfig";

const NotificationService = {
  GetNotification: () => {
    const request = api.get('Notification/GetNotificationById')
    return request.then((response) => {
      return response.data
    })
  },
  UpdateNotification: (id) => {
    const request = api.put(`Notification/UpdateNotification?notificationId=${id}`)
    return request.then((response) => {
      return response.data
    })
  }
}
export default NotificationService;